module.exports = __webpack_public_path__ + "img/sroki_piema.877fcb77.svg";